
import React from 'react';

const LoadingIndicator: React.FC = () => {
  return (
    <div className="text-center py-4">
      <div className="inline-block relative w-16 h-5">
        <div className="absolute top-0 w-3 h-3 rounded-full bg-[#0a0c1b]/30 animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="absolute top-0 left-5 w-3 h-3 rounded-full bg-[#0a0c1b]/60 animate-bounce" style={{ animationDelay: '250ms' }} />
        <div className="absolute top-0 left-10 w-3 h-3 rounded-full bg-[#0a0c1b]/90 animate-bounce" style={{ animationDelay: '500ms' }} />
      </div>
    </div>
  );
};

export default LoadingIndicator;
